import { render } from "./ChevronUp.vue?vue&type=template&id=5760df04"
import script from "./ChevronUp.vue?vue&type=script&lang=js"
export * from "./ChevronUp.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5760df04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5760df04', script)) {
    api.reload('5760df04', script)
  }
  
  module.hot.accept("./ChevronUp.vue?vue&type=template&id=5760df04", () => {
    api.rerender('5760df04', render)
  })

}

script.__file = "src/icons/components/filled/ChevronUp.vue"

export default script